<template>
  <div class="login">
    <m_header></m_header>
    <div class="login-box login-form">
      <form>
        <div class="login-logo">
          <img src="../assets/img/logo.jpg" alt="">
        </div>
        <div class="login-title">
          六十甲子管理系统
        </div>
        <div class="login-item">
<!--          <input v-model="info.phone" maxlength="11" @keyup.enter="submit()" type="text" class="login-item-input" placeholder="请输入手机号" />-->
          <el-input placeholder="请输入手机号" v-model="info.phone"></el-input>
        </div>
        <div class="login-item">
<!--          <input v-model="info.password" show-password maxlength="20" @keyup.enter="submit()" type="text" placeholder="请输入密码"/>-->
          <el-input placeholder="请输入密码" v-model="info.password" show-password></el-input>
        </div>
        <div v-loading="loading">
          <el-button type="primary" @click="submit()" class="login-btn">登录</el-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      loading: false,
      info: {
        phone: '',
        password: ''
      }
    }
  },
  methods: {
    submit () {
      let _this = this
      _this.loading = true
      let reg = /^1[3456789]\d{9}$/
      if (!reg.test(_this.info.phone)) {
        this.$message({
          message: '请输入有效的手机号码',
          center: true,
          type: 'error'
        })
        _this.loading = false
        return
      }
      if (_this.info.password === '') {
        this.$message({
          message: '请输入密码',
          center: true,
          type: 'error'
        })
        _this.loading = false
      }
    }
  }
}
</script>

<style scoped src="../assets/css/login.css"></style>



// WEBPACK FOOTER //
// src/components/Login.vue